// Role
const Listrole = () => import('@/views/admin-management/role/index')
const Formrole = () => import('@/views/admin-management/role/form')

export default {
    path: 'role',
    redirect: '/role',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'role',
            component: Listrole,
            meta: {
                link: 'role',
                breadcrumb: [
                    { title: 'Admin Management', active: true },
                    { title: 'Role', active: true },
                ],
                pageTitle: 'Role'
            }
        },
        {
            path: 'add',
            name: 'addrole',
            component: Formrole,
            meta: {
                link: 'role',
                breadcrumb: [
                    { title: 'Admin Management', active: true },
                    { title: 'Role', url: '/role' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Role'
            }
        },
        {
            path: 'edit/:id',
            name: 'editrole',
            component: Formrole,
            meta: {
                link: 'role',
                breadcrumb: [
                    { title: 'Admin Management', active: true },
                    { title: 'Role', url: '/role' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Role'
            }
        },
    ]
}